import { render, staticRenderFns } from "./WDialogToolbar.vue?vue&type=template&id=5ffc4692&scoped=true&"
import script from "./WDialogToolbar.vue?vue&type=script&setup=true&lang=js&"
export * from "./WDialogToolbar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc4692",
  null
  
)

export default component.exports